module.exports = __webpack_public_path__ + "img/estacionamiento.9ccd5194.svg";